import React from "react";


export const PickAmPmSlide = () => {
    return (
        <div className="swiper-container pickslide-day-when">
            <div className="swiper-wrapper">
                <div className="swiper-slide"><span>오전</span></div>
                <div className="swiper-slide"><span>오후</span></div>
            </div>
        </div>
    );
};
